import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { IconEdit, IconLoginGrey, TextHeadline3 } from '@blocket/blocket-ui'
import { fetchUserData } from 'reduxBits/privateProfile/actions'
import {
  Modal,
  Headline,
  CloseIcon,
  Wrapper,
  Column,
  NameColumn,
  EditButton,
  TextArea,
  TextWrapper,
  GuidText,
  ButtonWrapper,
  Button,
} from './style.js'
import log from 'sentry/log'
import { actionCreators as api } from 'reduxBits/api'
import { changeNameClickEvent } from 'tracking/profilePagePrivate'
import { VEND_CLIENT_ID, VEND_PROFILE_URL } from 'constants/vend'
import { validLength, validFormat, getPotentialErrorMessage } from './utilFunctions.js'

const EditModal = ({ userName = '', currentDescription, close }) => {
  const [description, setDescription] = useState(currentDescription || '') // backend gives us value null from start
  const [error, setError] = useState({ description: '' })
  const baseUrl = useSelector((state) => state.config.urls.base)
  const dispatch = useDispatch()

  const updateProfileUrl = `${VEND_PROFILE_URL}/about-you?response_type=code&client_id=${VEND_CLIENT_ID}&redirect_uri=${baseUrl}/mitt-blocket`

  const descriptionOnChange = (value) => {
    // prevent user from typing in to long text or add something other than a string.
    const lengthAndFormatOk = validLength(value) && validFormat(value)
    if (lengthAndFormatOk) {
      setDescription(value)
    }
    // to give user errormessage while typing
    setError({ ...error, description: getPotentialErrorMessage(value) })
  }

  const uploadUserData = async () => {
    // for now we let backend do the final validation,
    // so we don't bother about any existing frontend errors when doing a patch.
    const payload = { description: description }
    try {
      const response = await dispatch(
        api.fetch('profile-be/v1/profiles', {
          method: 'PATCH',
          body: JSON.stringify(payload),
        }),
      )
      if (response.status === 204) {
        dispatch(fetchUserData())
        close()
      } else {
        log.error(`Private profile error on patch: ${response.status}`)
      }
    } catch (e) {
      if (e.response.status === 400) {
        setError({ ...error, description: e.content.errors.description })
      }
    }
  }

  return (
    <Modal open onClose={close} label="lägg till personlig beskrivning">
      <Headline>Redigera Profil</Headline>
      <CloseIcon onClick={close} />
      <Wrapper>
        <IconLoginGrey width={94} height={94} />
        <Column>
          <NameColumn>
            <EditButton
              type="default"
              size="tiny"
              href={updateProfileUrl}
              onClick={() => changeNameClickEvent(updateProfileUrl)}
            >
              <IconEdit width={12} height={12} />
              Ändra visningsnamn
            </EditButton>
            <TextHeadline3>{userName}</TextHeadline3>
          </NameColumn>
          <TextArea
            label="Beskrivning om dig"
            value={description}
            name="description"
            errorText={error.description}
            status={error.description ? 'error' : 'success'}
            onChange={(e) => descriptionOnChange(e.target.value)}
          />
          {!error.description && (
            <TextWrapper>
              <GuidText>Telefonnummer, e-mail eller länkar är inte tillåtet</GuidText>
              <GuidText>{`${description?.length}/150`}</GuidText>
            </TextWrapper>
          )}
          <ButtonWrapper>
            <Button onClick={uploadUserData} type="primary">
              Spara
            </Button>
            <Button onClick={close}>Avbryt</Button>
          </ButtonWrapper>
        </Column>
      </Wrapper>
    </Modal>
  )
}

EditModal.propTypes = {
  close: PropTypes.func.isRequired,
  userName: PropTypes.string.isRequired,
  currentDescription: PropTypes.string,
}

export default EditModal
